export const defaultFormHeaders = Object.freeze({
    'accept': 'application/json',
    'content-type': 'multipart/form-data'
});

export function prepareAsFormData(data) {
    const formData = new FormData();
    for (const [ k, v ] of Object.entries(data)) {
        if (Array.isArray(v)) {
            for (const item of v) formData.append(k + '[]', item);
            continue;
        }
        formData.append(k, v);
    }
    return formData;
}
